import css from './brand-lockup.module.css';

// The site's mark, the sibling of riviera-todo.com's and dubai-todo.com's: the
// same gold sun over three bands — here straight Art Deco stripes, each shorter
// than the one above (Ocean Drive's facade lines, the sun's path on the sea):
// coral, aqua, the site's blue. Also the favicon (public/favicon.svg,
// favicon.ico, apple-touch-icon.png) — keep the paths in sync.
const RAYS = 'M24 3v3M24 26v3M11 16h3M34 16h3M15 7l2 2M31 23l2 2M33 7l-2 2M17 23l-2 2';
const STRIPE_CORAL = 'M6 35h36';
const STRIPE_AQUA = 'M10 40h28';
const STRIPE_BLUE = 'M15 45h18';

export function MiamiMark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      fill="none"
      stroke="#c7a35c"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false">
      <circle cx={24} cy={16} r={5.5} />
      <path d={RAYS} />
      <path d={STRIPE_CORAL} stroke="#f0997b" />
      <path d={STRIPE_AQUA} stroke="#3fb6bd" />
      <path d={STRIPE_BLUE} stroke="#1f5f91" />
    </svg>
  );
}

/** Mark over "MIAMI" over "— TO DO —", as the sister sites' lockups; `large` from 1024 px. The link around it carries the accessible name. */
export function BrandLockup({ large }: { large?: boolean }) {
  return (
    <span className={`${css.lockup} ${large ? css.large : ''}`}>
      <MiamiMark className={css.mark} />
      <span className={css.name}>MIAMI</span>
      <span className={css.sub}>
        <span className={css.rule} />
        TO DO
        <span className={css.rule} />
      </span>
    </span>
  );
}
